import Footer from "../Components/Footer";
import InnerNavbar from "./loginNavbar";
import {Box, Button, Container, Text} from "@chakra-ui/react"
import Heading from "../Components/Heading";

function Progress(){
    return (

        <>
        <InnerNavbar/>
        <Container minW="full" height="auto" padding = "0px">
            <Heading image = "https://www.gymwolf.com/img/header.jpg" text = "Progress"/>
            
            <Box style={{ width:"70%", margin : "auto", marginBottom:"20px"}}>
            <Box>
                    <Box borderBottom = "2px solid blue" py={12}>
                        <Text fontSize="xl" style={{textAlign:"center", }}>Gymwolf has certified personal trainers that provide you with customised workout plans depending on your goals. Our trainers track your progress, coach and motivate you daily through our web and smartphone app.</Text>
                    </Box>
                    <Box mt={10}>
                    <Text fontSize="4xl" as = "b">Our Trainers</Text>
                    </Box>
                    <Box style = {{display : "flex", gap : "5%"}} mt = {8}>
                        <Box  width ="30%"><img src="https://www.gymwolf.com/user_images/0db67d7bc0ced122b636098c6c7b6c9b_1530024726.jpg" alt="img" width ="100%"/></Box>
                        <Box width="65%" style={{textAlign : "left",}}>
                            <Box>
                                <Text fontSize = "3xl" as = "b">Siim Savisaar</Text>
                            </Box>
                            <Box mt={4}>
                                <Text fontSize="19px">Siim is a university-trained practising physiotherapist, personal trainer and a world-class bodybuilder. He’s a strong believer in what doesn’t challenge you, won’t change you. Thus, you should expect to be challenged if you work with him. Siim has extensive experience, from working with people with special needs to training elite athletes from freestyle skiing to bodybuilding and bikini fitness. His speciality is physical conditioning along with strength and hypertrophy programs.</Text>
                            </Box>
                            <Box mt={6}> 
                                <Button
                                  style={{
                                    padding: "30px 60px 30px 60px",
                                    fontSize: "20px",
                                    boxShadow: "1px 1px 4px rgb(0 0 0 / 50%)",
                                  }}
                                  colorScheme="green"
                                  variant="solid"
                                >
                                  Choose The Trainer
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    <Box style = {{display : "flex", gap : "5%"}} mt = {8}>
                        <Box  width ="30%"><img src="https://www.gymwolf.com/user_images/a0e65be4dba72b3d37d0e490a8173d73_1596110163.jpg" alt="img" width ="70%" /></Box>
                        <Box width="65%" style={{textAlign : "left"}} >
                            <Box>
                                <Text fontSize = "3xl" as = "b">Taavi Merisalu</Text>
                            </Box>
                            <Box mt={4}>
                                <Text fontSize="19px">Taavi on lõpetanud Tartu Ülikooli sporditeaduste ja füsioteraapia instituudi. Tema spetsialiteet on raskejõustik, rahvasport ja personaaltreeningud. Enesetäiendamist ei ole ta lõpetanud - täiendab ennast pidevalt tänapäevaste uuringutega, et hoida oma meetodid võimalikult teaduspõhised. Lisaks teiste treenimisele treenib ta ka iseennast ja on väga edukas kulturist Eestis. Mitmeid kordi on saavutanud medalikohti Eesti sisevõistlustel ja ka välisvõistlustel. Taavi treenitavate käes on üle 20 Eesti rekordi jõutõstmises. Lisaks rekorditele on tema õpilased toonud Eestile 5 medalit Euroopa Meistrivõistlustelt.</Text>
                            </Box>
                            <Box mt={6}> 
                                <Button
                                  style={{
                                    padding: "30px 60px 30px 60px",
                                    fontSize: "20px",
                                    boxShadow: "1px 1px 4px rgb(0 0 0 / 50%)",
                                  }}
                                  colorScheme="green"
                                  variant="solid"
                                >
                                  Choose The Trainer
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                </Box>
            </Box>

        </Container>
        
        <Footer/>
        </>
        
    )
        
    
}
export default Progress;